export class ModuleRequest {
    name: string;
}